"use client";

export function PipelineDiagram({ className = "" }: { className?: string }) {
  const nodes = [
    { cx: 60, cy: 52 },
    { cx: 168, cy: 118 },
    { cx: 60, cy: 184 },
    { cx: 168, cy: 250 },
  ];

  return (
    <div className={`relative ${className}`} aria-hidden>
      <svg viewBox="0 0 228 302" className="h-full w-full" fill="none">
        <defs>
          <linearGradient id="pipe-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--color-primary-light)" />
            <stop offset="50%" stopColor="var(--color-primary)" />
            <stop offset="100%" stopColor="var(--color-primary-dark)" />
          </linearGradient>
        </defs>

        {/* connective spine: the wire the nodes sit on */}
        <path
          d="M60 52 L168 118 L60 184 L168 250"
          stroke="var(--color-border)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M60 52 L168 118 L60 184 L168 250"
          stroke="url(#pipe-grad)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeDasharray="360"
          className="motion-safe:animate-[pipelineDraw_6s_ease-in-out_infinite]"
          style={{ strokeDashoffset: 0 }}
        />

        {/* faint circuit branches — the logo's motif, kept quiet */}
        {nodes.map((n, i) => (
          <g key={i} opacity="0.35">
            <path
              d={`M${n.cx} ${n.cy} L${i % 2 === 0 ? n.cx - 34 : n.cx + 34} ${n.cy - 22}`}
              stroke="var(--color-border)"
              strokeWidth="1"
              strokeLinecap="round"
            />
            <circle
              cx={i % 2 === 0 ? n.cx - 34 : n.cx + 34}
              cy={n.cy - 22}
              r="2.5"
              fill="var(--color-border)"
            />
          </g>
        ))}

        {nodes.map((n, i) => (
          <g key={`node-${i}`}>
            <circle
              cx={n.cx}
              cy={n.cy}
              r="16"
              fill="var(--color-bg)"
              stroke="var(--color-primary)"
              strokeOpacity="0.4"
              strokeWidth="1"
            />
            <circle
              cx={n.cx}
              cy={n.cy}
              r="5"
              fill="var(--color-primary)"
              className="motion-safe:animate-[pipelinePulse_3s_ease-in-out_infinite]"
              style={{ animationDelay: `${i * 0.5}s` }}
            />
          </g>
        ))}
      </svg>
    </div>
  );
}
